import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ThemeType } from './types';
import { FormControlLabel, RadioGroup, FormControl, Radio } from '@mui/material';
import { useState } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { selectThemeType } from 'console/theme/selector';
export function ThemeElement(props) {
    const { value, onChange } = props;
    const theme_type = useAppSelector(selectThemeType);
    const [chosen_theme, setChosenTheme] = useState(value ?? theme_type);
    const onChangeTheme = (event) => {
        const new_theme = parseInt(event.target.value, 10);
        onChange(new_theme);
        setChosenTheme(new_theme);
    };
    return (_jsx(FormControl, { children: _jsxs(RadioGroup, { row: true, value: chosen_theme, onChange: onChangeTheme, children: [_jsx(FormControlLabel, { value: ThemeType.LIGHT, control: _jsx(Radio, { color: "primary" }), label: "\u0421\u0432\u0435\u0442\u043B\u0430\u044F", labelPlacement: "top" }), _jsx(FormControlLabel, { value: ThemeType.SYSTEM, control: _jsx(Radio, { color: "primary" }), label: "\u0421\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F", labelPlacement: "top" }), _jsx(FormControlLabel, { value: ThemeType.DARK, control: _jsx(Radio, { color: "primary" }), label: "\u0422\u0451\u043C\u043D\u0430\u044F", labelPlacement: "top" })] }) }));
}
